import { doc, getDoc } from 'firebase/firestore'
import { db } from '../firebase-config'
import { TABLA_TOPES as FALLBACK_TOPES, RENTAS_AUTONOMOS as FALLBACK_RENTAS } from '../config/normativaDictamen'

const NORMATIVE_CONFIG_COLLECTION = 'normative_config'
const NORMATIVE_CONFIG_DOC = 'current'

/**
 * Fetches normative config (topes + rentas) from Firestore.
 * Always returns data — falls back to the hardcoded TABLA_TOPES / RENTAS_AUTONOMOS
 * when Firestore is unreachable or the document doesn't exist yet.
 *
 * Returns: { success, data: { topes, rentas }, source, version?, error?, note? }
 */
export async function getNormativeConfig() {
  try {
    const docRef = doc(db, NORMATIVE_CONFIG_COLLECTION, NORMATIVE_CONFIG_DOC)
    const snap = await getDoc(docRef)
    if (snap.exists()) {
      const data = snap.data()
      return {
        success: true,
        data: {
          topes: data.topes || FALLBACK_TOPES,
          rentas: data.rentas || FALLBACK_RENTAS,
        },
        source: 'firestore',
        version: data.version || 'unknown',
      }
    }
    // Document doesn't exist yet — use fallback
    return {
      success: true,
      data: { topes: FALLBACK_TOPES, rentas: FALLBACK_RENTAS },
      source: 'fallback',
      note: 'No Firestore document found. Using hardcoded defaults.',
    }
  } catch (err) {
    console.warn('[normativeConfigService] Firestore fetch failed, using fallback:', err.message)
    return {
      success: false,
      data: { topes: FALLBACK_TOPES, rentas: FALLBACK_RENTAS },
      source: 'fallback',
      error: err,
    }
  }
}
